import React from "react";
import {useTranslation} from "react-i18next";

import MDInput from "materialDashboard/components/MDInput";
import {getIn} from "formik";


const Model23Select = ({
                           name,
                           registry,
                           formik,
                           labelFn = r => `${r.code} - ${r.observation}`,
                           onChange,
                           attrValue = 'code',
                           ...props
                       }) => {
    const {t} = useTranslation(['models23']);

    const value = getIn(formik.values, name);
    const error = getIn(formik.errors, name);
    const touched = getIn(formik.touched, name);

    return <MDInput select
                    SelectProps={{native: true}} // use native select to support select-by-typing and arrow select without opening menu
                    name={name}
                    label={t(`model23Form.${name}`)}
                    value={value ?? ''}
                    onChange={onChange === undefined ? formik.handleChange : onChange}
                    error={touched && Boolean(error)}
                    helperText={touched && error}
                    variant="standard"
                    fullWidth
                    {...props}>
        <option label=""></option>
        {
            registry.map((r) => <option key={r[attrValue]} value={r[attrValue]}>{labelFn(r)}</option>)
        }
    </MDInput>
}

export default Model23Select;